<template>
  <div class="acc-alerts">
    <div class="tile-title">
      {{ label }}
    </div>
    <br>
    <slot></slot>
    <br>
  </div>
</template>

<script>
export default {
  name: 'BorderedContainer',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .acc-alerts {
    border: solid 2px;
    position: relative;
    padding: 0 1em;
    .tile-title {
      position: absolute;
      top: -15px;
      left: 10px;
      background: white;
      font-size: 18px;
      font-weight: 400;
      padding: 0 .25em;
    }
  }
</style>